import { useState } from "react";
import { useTransition, animated, config } from "@react-spring/web";
import dayjs from "dayjs";
import { useDashboard } from "../../providers/dashboard";

const mapping = {
    "order": "Ordre",
    "invoice": "Faktura",
    "offer": "Tilbud",
    "creditmemo": "Kreditnota"
}



const SelectorEntry = ({ entry, onClick }) => {
    const [n, arr] = entry;
    const { state } = useDashboard();
    const [isOpen, setIsOpen] = useState(false);

    const trans = useTransition(isOpen ? arr : [], {
        config: config.stiff,
        trail: 100,
        from: {
            opacity: 0
        },
        enter: {
            opacity: 1
        },
        leave: {
            opacity: 0
        }
    })

    return (
        <>
            <div
                className={`bg-white p-3 rounded-md shadow-md border-l-8 ${isOpen ? "border-skgRed" : "border-skgBlue"} cursor-pointer transition-all`}
                onClick={() => setIsOpen(p => !p)}
            >
                <p
                    className="text-xs"
                >
                    {"STATUS: " + mapping[arr[0].type].toUpperCase()}
                </p>
                <p>
                    {n + " - " + dayjs(arr[0].updated_at).format("DD/MM/YYYY")}
                </p>
            </div>
            {
                trans((style, item) => {
                    return (
                        <animated.div
                            className={`p-3 ml-2 shadow-md rounded-md ${item.id === state?.selectedDetail?.id ? "bg-skgBlue text-white" : "bg-white text-skgBlue"} transition-all cursor-pointer`}
                            style={style}
                            onClick={() => {
                                onClick(item.type, item.id)
                                console.log(item)
                            }}
                        >
                            {
                                mapping[item.type]
                            }
                        </animated.div>
                    )
                })
            }
        </>
    )
}

export default SelectorEntry;